<template>
  <v-alert
    v-if="status && !forbiddenRoutes"
    :value="true"
    type="info"
    class="mode-banner ma-0"
    tile
  >
    In setup mode, please don't forget to fully
    <router-link
      to="/admin/setup-accounts"
      class="white--text white--link"
    >
      setup your account
    </router-link>!
  </v-alert>
</template>

<script>
  export default {
    name: 'HeaderSetupModeBanner',
    computed: {
      status () {
        const setupMode = this.$store.getters.getSetupMode
        return setupMode ? setupMode.status : false
      },
      forbiddenRoutes () {
        const routes = ['SetupChecklist', 'SetupChecklistSelectedTask', 'NewAdvertiser']
        return routes.find(route => route === this.$route.name)
      }
    }
  }
</script>

<style scoped>
.mode-banner {
  position: relative;
  width: 100%;
}
</style>
